import { profileConstant } from "../constants";

const initialState = {
  loading: false,
  appConfig: {
    isCustomDomain: false,
    title: "Flozy",
    description: "",
    favicon: "https://sweetp-user-uploads.s3.eu-west-2.amazonaws.com/stage/1711086718231_favicon.ico",
    logo: "",
    icon: "",
    theme: "light",
    light: {
      logo: "",
      icon: ""
    },
    dark: {
      logo: "",
      icon: ""
    },
    loading: false
  },
  profile: {},
  profileDetailCount: {},
  profileNameList: [],

  teamUsers: [],
  teamClients: [],
  inviteUser: [],
  copyTeamInviteLink: "",
  invitation: false,
  invitationData: null,

  notifications_n: [],
  totalNotificationsCount:{},
  notifications_count: {
    allNewMsgCount: 0,
    newMsgData: {
      jobMsgCount: null,
      clientMsgCount: null,
      teamMsgCount: null,
    },
    notificationMsgCount: 0,
  },
  invites_n: [],
  tasks_n: [],
  invoice_n: [],
  workspace_n: [],
  others_n:[],

  funnel_n: [],
  agency_notification: {},
  global: [],
  newMessage: {},
  newInvite: {
    inviteUser: [],
    userRole: null,
    inviteFlows: [],
    inviteInternalClients: [],
    inviteExternalClients: [],
    flowFullAccess: false,
    internalClientFullAccess: false,
    externalClientFullAccess: false,
    inviteMessage: null,
  },
  newClientInvite: {
    inviteUser: [],
    inviteInternalClients: [],
    inviteExternalClients: [],
    internalClientFullAccess: false,
    externalClientFullAccess: false,
    inviteMessage: null,
  },
  projects: [],
  internal_clients: [],
  external_clients: [],
  current_payment_link: [],
  user_payment_links: [],

  domainDetails: {},

  agencyEmailConfig: {
    authentication_type: 2,
    service: "other"
  },
  authURL: '',
  configuredApps: [],
  configuredAppsInfo: [],
  googleEmailId: '',
  outlookEmailId: '',
  applicationApps: [],
  getClonedStatus:{},
};

export default function profile(state = initialState, action) {
  switch (action.type) {

    //Application Config For White Labeled Agencies
    case profileConstant.GET_APP_CONFIG_R:
      return {
        ...state,
        appConfig: {
          ...initialState.appConfig,
        },
      };

    //Application Config For White Labeled Agencies
    case profileConstant.GET_APP_CONFIG_S:
      return {
        ...state,
        appConfig: {
          ...action.data,
          loading: true
        },
      };

    //Application Config For White Labeled Agencies
    case profileConstant.GET_APP_CONFIG_F:
      return {
        ...state,
        appConfig: {
          ...initialState.appConfig,
          loading: false
        },
      };

    //update profile reducer
    case profileConstant.UPDATE_CREATE_PROFILE:
      return {
        ...state,
        profile: action.data,
      };

    case profileConstant.UPDATE_PROFILE_PUBLIC_PAGE:
      return{
        ...state,
        profile: action.data,
      }

    case profileConstant.CLEAR_PROFILE:
      return {
        ...state,
        profile: {},
      };

    case profileConstant.CREATE_PROFILE_R:
      return {
        ...state,
      };
    case profileConstant.CREATE_PROFILE_S:
      return {
        ...state,
        // profile: {}
      };
    case profileConstant.CREATE_PROFILE_F:
      return {
        ...state,
      };

    case profileConstant.GET_PROFILES_R:
      return {
        ...state,
      };
    case profileConstant.GET_PROFILES_S:
      return {
        ...state,
        profile: action.data.data,
      };
    case profileConstant.GET_PROFILES_F:
      return {
        ...state,
      };

    case profileConstant.UPDATE_AGENCY_DETAILS_R:
      return{
        ...state
      }
    case profileConstant.UPDATE_AGENCY_DETAILS_S:
      return{
        ...state,
        profile: action.data.data
      }
      case profileConstant.UPDATE_AGENCY_DETAILS_F:
      return {
        ...state,
      };

    case profileConstant.GET_PROFILES_NAMES_R:
      return {
        ...state,
        profileNameList: [],
      };
    case profileConstant.GET_PROFILES_NAMES_S:
      return {
        ...state,
        profileNameList: action.data.data,
      };
    case profileConstant.GET_PROFILES_NAMES_F:
      return {
        ...state,
        profileNameList: [],
      };

    case profileConstant.NAME_REDUCER_UPDATE:
      return {
        ...state,
        profileNameList: action.data,
      };

    //**************************************************TEAMS************************************************************* */

    case profileConstant.GET_PROJECT_USERS_R:
      return {
        ...state,
      };
    case profileConstant.GET_PROJECT_USERS_S:
      return {
        ...state,
        teamUsers: action.data.data,
      };
    case profileConstant.GET_PROJECT_USERS_F:
      return {
        ...state,
        teamUsers: [],
      };

    case profileConstant.GET_PROJECT_CLIENTS_R:
      return {
        ...state,
      };
    case profileConstant.GET_PROJECT_CLIENTS_S:
      return {
        ...state,
        teamClients: action.data.data,
      };
    case profileConstant.GET_PROJECT_CLIENTS_F:
      return {
        ...state,
        teamClients: [],
      };

    case profileConstant.UPDATE_ROLE:
      return {
        ...state,
        teamUsers: action.data,
      };

    case profileConstant.UPDATE_INVITE_USER:
      return {
        ...state,
        newInvite: action.data,
      };

    case profileConstant.UPDATE_CLIENT_INVITE:
      return {
        ...state,
        newClientInvite: action.data,
      };

    case profileConstant.INVITE_N_USERS_R:
      return {
        ...state,
        newInvite: initialState.newInvite,
      };
    case profileConstant.INVITE_N_USERS_S:
      return {
        ...state,
        inviteUser: [],
        newInvite: {
          ...initialState.newInvite,
          inviteMessage: action.data.inviteMessage,
        },
      };
    case profileConstant.INVITE_N_USERS_F:
      return {
        ...state,
        inviteUser: [],
        newInvite: initialState.newInvite,
      };

    case profileConstant.INVITE_N_CLIENT_USERS_R:
      return {
        ...state,
        newClientInvite: initialState.newClientInvite,
      };
    case profileConstant.INVITE_N_CLIENT_USERS_S:
      return {
        ...state,
        newClientInvite: {
          ...initialState.newInvite,
          inviteMessage: action.data.inviteMessage,
        },
      };
    case profileConstant.INVITE_N_CLIENT_USERS_F:
      return {
        ...state,
        newClientInvite: initialState.newClientInvite,
      };

    //User Invitation Details
    case profileConstant.G_NEW_USER_U_ACCEPT_R:
      return {
        ...state,
      };
    case profileConstant.G_NEW_USER_U_ACCEPT_S:
      return {
        ...state,
        invitationData: action.data.data,
      };
    case profileConstant.G_NEW_USER_U_ACCEPT_F:
      return {
        ...state,
        invitationData: initialState.invitation,
      };

    //USER INVITATION ACCEPT
    case profileConstant.NEW_USER_U_ACCEPT_R:
      return {
        ...state,
      };
    case profileConstant.NEW_USER_U_ACCEPT_S:
      return {
        ...state,
        invitation: action.data.data,
      };
    case profileConstant.NEW_USER_U_ACCEPT_F:
      return {
        ...state,
        invitation: initialState.invitation,
      };

    //**************************************************NOTIFICATIONS************************************************************* */

    case profileConstant.GET_NOTIFICATIONS_R:
      return {
        ...state,
        loading: true
      };
    case profileConstant.GET_NOTIFICATIONS_S:
      const prevNotificationIds = new Set((state.notifications_n || []).map((m) => `${m.id}`));

      // Fix: action.data = { data: response, params }
      // response = { status, data: { result, count, pendingChat } }
      // So we need action.data.data.data to get the inner data object
      const responseData = action.data?.data?.data || action.data?.data || {};
      const updatedChatCount = responseData.count?.allNewMsgCount || 0;
      const list_offset = action.data?.params?.offset || 0
      const newNotifications = (responseData.result || []).filter((f) => {
        const idStr = `${f.id}`;
        if (!prevNotificationIds.has(idStr)) {
          prevNotificationIds.add(idStr);
          return true;
        }
        return false;
      });

      const combinedNotifications = [
        ...state.notifications_n,
        ...newNotifications
      ];
    
      combinedNotifications.sort((a, b) => new Date(b.notification_time) - new Date(a.notification_time));

      const updatedTotalCount = {
        ...state.totalNotificationsCount,
        chat_count : updatedChatCount || 0,
        total_chat_count : responseData.count?.totalNotification || 0,
        total_count : updatedChatCount + state.totalNotificationsCount.other_count + state.totalNotificationsCount.other_workspace + state.totalNotificationsCount.task_count || 0,
      }
    
      return {
        ...state,
        pendingChat: responseData.pendingChat || false,
        loading: false,
        totalNotificationsCount : list_offset && updatedChatCount === 0 ? {...state.totalNotificationsCount} : updatedTotalCount,
        notifications_n: list_offset ? combinedNotifications : (responseData.result || []),
        notifications_count: list_offset && updatedChatCount === 0 ? {...state.notifications_count} : responseData.count || 0,
      };

      case profileConstant.UPDATE_SELECT_NOTIFICATION:
        const updatedNotificationList = action.params || [];  
        return {
          ...state,
          notifications_n: updatedNotificationList
        };
      
    case profileConstant.GET_NOTIFICATIONS_F:
      return {
        ...state,
        loading: false,
        notifications_n: [],
      };

    case profileConstant.UPDATE_CHAT_S:
      return {
        ...state,
        notifications_n: [...state.notifications_n, ...action.data.data?.result],
        loading: false,
        pendingChat: action.data.data?.pendingChat,
        totalNotificationsCount : {
          ...state.totalNotificationsCount,
          chat_count : action.data.data?.count.allNewMsgCount || 0,
          total_count: state.totalNotificationsCount.chat_count + state.totalNotificationsCount.other_count + state.totalNotificationsCount.other_workspace + state.totalNotificationsCount.task_count || 0,

        },
      };   

    case profileConstant.GET_TASKS_R:
      return {
        ...state,
      };
    case profileConstant.GET_TASKS_S:
      const updatedTask =action.data.data?.taskCount;
      return {
        ...state,
        loading: false,
        tasks_n: action.data.data?.result,
        pendingTask: action.data.data?.pendingTask,
        totalNotificationsCount : {
          ...state.totalNotificationsCount,
          task_count : updatedTask || 0,
          total_task_count : action.data.data.totalNotification || 0,
          total_count: state.totalNotificationsCount.chat_count + state.totalNotificationsCount.other_count + state.totalNotificationsCount.other_workspace + updatedTask || 0,

        },
      };
    case profileConstant.GET_TASKS_F:
      return {
        ...state,
        loading: false,
        tasks_n: state.tasks_n,
      };

    case profileConstant.UPDATE_TASKS_S:
      return {
        ...state,
        tasks_n: [...state.tasks_n, ...action.data.data?.result],
        pendingTask: action.data.data?.pendingTask,
        loading: false,
        totalNotificationsCount : {
          ...state.totalNotificationsCount,
          tasksCount : action.data.data?.taskCount || 0,
          total_task_count:action.data.data?.totalNotification || 0,
          total_count: state.totalNotificationsCount.chat_count + state.totalNotificationsCount.other_count + state.totalNotificationsCount.other_workspace + state.totalNotificationsCount.task_count || 0

        },
      }; 

    case profileConstant.UPDATE_AGENCY_NOTIFICATION_S:
      return {
        ...state,
        agency_notification: {
          ...state.agency_notification,
          [action.data.agency_id]: {
            ...action.data.notificationData,
          },
        },
      };
    case profileConstant.WORKSPACE_NOTIFICATION_S:
      const updated_OtherWorkspace_count=action?.data?.data?.workspaceCount;
      return {
        ...state,
        loading: false,
        workspace_n: action?.data?.data?.workspace_n,
        pendingWorkspace: action?.data?.data?.pendingWorkspace,
        totalNotificationsCount : {
          ...state.totalNotificationsCount,
          other_workspace : updated_OtherWorkspace_count || 0,
          total_workspace_count : action?.data?.data?.totalNotification || 0,
          total_count: state.totalNotificationsCount.chat_count + state.totalNotificationsCount.other_count + updated_OtherWorkspace_count + state.totalNotificationsCount.task_count || 0

        },
      };

      case profileConstant.UPDATE_WORKSPACE_NOTIFICATION_S:
        return {
          ...state,
          workspace_n: [...state.workspace_n, ...action?.data?.data?.workspace_n],
          totalNotificationsCount : {
            ...state.totalNotificationsCount,
            other_workspace : action?.data?.data?.workspaceCount || 0,
            total_workspace_count : action?.data?.data?.totalNotification || 0,
            total_count: state.totalNotificationsCount.chat_count + state.totalNotificationsCount.other_count + state.totalNotificationsCount.other_workspace + state.totalNotificationsCount.task_count || 0
          },
          pendingWorkspace: action?.data?.data?.pendingWorkspace,
          loading: false,
        };

      case profileConstant.GET_OTHER_S:
        return {
          ...state,
          loading: false,
          others_n: action?.data?.data?.result,
          pendingOthers: action.data.data?.pendingOthers,
          totalNotificationsCount : {
            ...state.totalNotificationsCount,
            other_count : action.data.data?.othersCount || 0,
            total_other_count : action.data.data?.totalNotification || 0,
            total_count: state.totalNotificationsCount.chat_count + state.totalNotificationsCount.other_count + state.totalNotificationsCount.other_workspace + state.totalNotificationsCount.task_count || 0


          },
        };  

    case profileConstant.UPDATE_OTHERS_S:
      return {
        ...state,
        others_n: [...state.others_n, ...action?.data?.data?.result],
        pendingOthers: action.data.data?.pendingOthers,
        totalNotificationsCount : {
          ...state.totalNotificationsCount,
          other_count : action.data.data?.othersCount || 0,
          total_other_count : action.data.data?.totalNotification || 0,
          total_count: state.totalNotificationsCount.chat_count + state.totalNotificationsCount.other_count + state.totalNotificationsCount.other_workspace + state.totalNotificationsCount.task_count || 0

        },
        loading: false,
      };
    case profileConstant.GET_TEAM_INVITE_LINK_R:
      return {
        ...state,
      };
    case profileConstant.GET_TEAM_INVITE_LINK_S:
      return {
        ...state,
        copyTeamInviteLink: action.data.data,
      };
    case profileConstant.GET_TEAM_INVITE_LINK_F:
      return {
        ...state,
        copyTeamInviteLink: "",
      };

    //**************************************************COMMON************************************************************* */
    case profileConstant.GET_GLOBAL_R:
      return {
        ...state,
        global: [],
      };
    case profileConstant.GET_GLOBAL_S:
      return {
        ...state,
        global: action.data.data,
      };
    case profileConstant.GET_GLOBAL_F:
      return {
        ...state,
        global: [],
      };

    //**************************************************File Constant************************************************************* */
    case profileConstant.GET_INVITES_FLOWS_AND_CLIENTS_R:
      return {
        ...state,
        projects: initialState.projects,
        internal_clients: initialState.internal_clients,
        external_clients: initialState.external_clients,
      };
    case profileConstant.GET_INVITES_FLOWS_AND_CLIENTS_S:
      return {
        ...state,
        projects: action.data.projects,
        internal_clients: action.data.internal_clients,
        external_clients: action.data.external_clients,
      };
    case profileConstant.GET_INVITES_FLOWS_AND_CLIENTS_F:
      return {
        ...state,
        projects: initialState.projects,
        internal_clients: initialState.internal_clients,
        external_clients: initialState.external_clients,
      };

    case profileConstant.GET_AGENCCY_DETAIL_COUNT_R:
      return {
        ...state,
        profileDetailCount: initialState.profileDetailCount,
      };
    case profileConstant.GET_AGENCCY_DETAIL_COUNT_S:
      return {
        ...state,
        profileDetailCount: action.data,
      };
    case profileConstant.GET_AGENCCY_DETAIL_COUNT_F:
      return {
        ...state,
        profileDetailCount: initialState.profileDetailCount,
      };

    case profileConstant.UPDATE_NEW_MESSAGE:
      return {
        ...state,
        newMessage: action.data,
      };

      case profileConstant.CLEAR_NOTIFICATIONS_S:
        let { invites_n, tasks_n, notifications_n, invoice_n, funnel_n } = state;
      
        if (action.data.noti_type === "message" && action?.data?.group_id) {
          notifications_n = notifications_n.filter(
            (n) => n.job_id !== action?.data?.group_id
          );
        } else if (action.data.noti_type === "message") {
          notifications_n = [];
          const updatedChatCount = 0; 
          return {
            ...state,
            notifications_n,
            totalNotificationsCount: {
              ...state.totalNotificationsCount,
              chat_count: updatedChatCount,
              total_count:
                updatedChatCount +
                state.totalNotificationsCount.other_count +
                state.totalNotificationsCount.other_workspace +
                state.totalNotificationsCount.task_count || 0,
            },
          };
        }
      
        // Clear invites
        if (action.data.noti_type === "invite") {
          invites_n = [];
        }
      
        // Clear tasks
        if (action.data.noti_type === "task") {
          const updatedTaskCount = 0; 
          tasks_n = [];
          return {
            ...state,
            notifications_n,
            totalNotificationsCount: {
              ...state.totalNotificationsCount,
              task_count: updatedTaskCount,
              total_count:
              state.totalNotificationsCount.chat_count +
              state.totalNotificationsCount.other_count +
                state.totalNotificationsCount.other_workspace +
                updatedTaskCount || 0,
            },
          };
        }
      
        // Clear invoices
        if (action.data.noti_type === "invoice") {
          invoice_n = [];
        }
      
        // Clear funnels
        if (action.data.noti_type === "funnel") {
          funnel_n = [];
        }
      
        return {
          ...state,
          invites_n,
          tasks_n,
          invoice_n,
          notifications_n,
          funnel_n,
        };
      
    // case profileConstant.UPDATE_SHOW_LOGO_S:
    // return {
    //   ...state,
    //   profile: {
    //     ...state.profile,
    //     profile: {
    //       ...state.profile.profile,
    //       custom_app_logo: action.data
    //     }
    //   }
    // };
    case profileConstant.UPDATE_NOTIFICATIONS_S:
      const { ids, id } = action.data;
      const notificationId = ids || id; // Support both ids (array) and id (singular)
      const updatedCount = state.notifications_count
      let updatedNotificationsUpdate = state.notifications_n;
      if (notificationId === "all") {
        updatedNotificationsUpdate = [];
        if (updatedCount?.allNewMsgCount) {
          updatedCount["allNewMsgCount"] = 0
          updatedCount["notificationMsgCount"] = 0
        }
      } else if (Array.isArray(notificationId) && notificationId.length > 0) {
        // Handle array of IDs
        updatedNotificationsUpdate = updatedNotificationsUpdate.filter(
          (notification) => !notificationId.includes(String(notification.id))
        );
        if (updatedCount?.allNewMsgCount) {
          updatedCount["allNewMsgCount"] = updatedCount?.allNewMsgCount - notificationId.length || 0
          updatedCount["notificationMsgCount"] = updatedCount?.notificationMsgCount - notificationId.length || 0
        }
      } else if (notificationId) {
        // Handle single ID (string or number)
        updatedNotificationsUpdate = updatedNotificationsUpdate.filter(
          (notification) => String(notification.id) !== String(notificationId)
        );
        if (updatedCount?.allNewMsgCount) {
          updatedCount["allNewMsgCount"] = updatedCount?.allNewMsgCount > 0 ? updatedCount.allNewMsgCount - 1 : 0
          updatedCount["notificationMsgCount"] = updatedCount?.notificationMsgCount > 0 ? updatedCount?.notificationMsgCount - 1 : 0
        }
      }
      return {
        ...state,
        notifications_n: updatedNotificationsUpdate,
        notifications_count: updatedCount,
        loading: false,
      };
  
      case profileConstant.UPDATEREADSTATUS_S: {
        const data = action.data;
        const key = {
            team: 'teamMsgCount',
            job: 'jobMsgCount',
            client: 'clientMsgCount',
        };
        const findKey = key[data?.type];
        if (!findKey) return state;
    
        const currentRoomValue = state.notifications_count.newMsgData[findKey]?.[data?.room_id] || 0;
        const allNewMsgCount =(state.notifications_count.allNewMsgCount || 0) - currentRoomValue;
        const { [data?.room_id]: _, ...updatedKeyValues } = state.notifications_count.newMsgData[findKey] || {};
    
        return {
            ...state,
            notifications_count: {
                ...state.notifications_count,
                newMsgData: {
                    ...state.notifications_count.newMsgData,
                    [findKey]: updatedKeyValues, 
                },
                allNewMsgCount, 
            },
        };
    }
    

    //total notification count
    case profileConstant.GET_NOTIFICATIONCOUNTS_S:
      return{
        ...state,
        totalNotificationsCount:action.data
      }
    
    case profileConstant.DELETE_NOTIFICATION_S: {
      const { id: deletedId, ids: deletedIds, tabValue } = action.data;
      let updatedNotifications;
      if (tabValue == 0) {
        updatedNotifications = state.notifications_n;
      } else if (tabValue == 1) {
        updatedNotifications = state.tasks_n;
      } else if (tabValue == 2) {
        updatedNotifications = state.others_n;
      }
      else {
        updatedNotifications = state.workspace_n;
      }
      let updatedTotalNotificationsCount = { ...state.totalNotificationsCount };

      if (deletedId) {
        updatedNotifications = updatedNotifications.filter(
          (notification) => notification.id !== deletedId
        );

        if (tabValue === 0 && updatedTotalNotificationsCount.chat_count > 0) {
          updatedTotalNotificationsCount.chat_count -= 1;
        } else if (tabValue === 1 && updatedTotalNotificationsCount.task_count > 0) {
          updatedTotalNotificationsCount.task_count -= 1;
        } else if (tabValue === 2 && updatedTotalNotificationsCount.other_count > 0) {
          updatedTotalNotificationsCount.other_count -= 1;
        } else if(tabValue === 3 && updatedTotalNotificationsCount.other_workspace > 0){
          updatedTotalNotificationsCount.other_workspace -= 1;
        }
      }

      if (deletedIds && deletedIds.length > 0) {
        updatedNotifications = updatedNotifications.filter(
          (notification) => !deletedIds.includes(notification.id)
        );

        if (tabValue === 0 && updatedTotalNotificationsCount.chat_count > 0) {
          updatedTotalNotificationsCount.chat_count -= deletedIds.length;
        } else if (tabValue === 1 && updatedTotalNotificationsCount.task_count > 0) {
          updatedTotalNotificationsCount.task_count -= deletedIds.length;
        } else if (tabValue === 2 && updatedTotalNotificationsCount.other_count > 0) {
          updatedTotalNotificationsCount.other_count -= deletedIds.length;
        } else if(tabValue === 3 && updatedTotalNotificationsCount.other_workspace > 0){
          updatedTotalNotificationsCount.other_workspace -= deletedIds.length;
        }
      }

      const total_count =
        updatedTotalNotificationsCount.chat_count +
        updatedTotalNotificationsCount.task_count +
        updatedTotalNotificationsCount.other_count +
        updatedTotalNotificationsCount.other_workspace;

      return {
        ...state,
        ...(tabValue === 0 && { notifications_n: updatedNotifications }),
        ...(tabValue === 1 && { tasks_n: updatedNotifications }),
        ...(tabValue === 2 && { others_n: updatedNotifications }),
        ...(tabValue === 3 && { workspace_n: updatedNotifications }),
        totalNotificationsCount: {
          ...updatedTotalNotificationsCount,
          total_count,
        },
      };
    }
      
      
    case profileConstant.UPDATE_CUSTOM_DOMAIN_S:
    case profileConstant.UPDATE_CUSTOM_DOMAIN_F:
    case profileConstant.UPDATE_CUSTOM_DOMAIN_R:
      return { ...state }

    case profileConstant.GET_CUSTOM_DOMAIN_DETAILS_R:
      return {
        ...state,
        domainDetails: initialState.domainDetails
      };
    case profileConstant.GET_CUSTOM_DOMAIN_DETAILS_S:
      return {
        ...state,
        domainDetails: action.data.data
      };
    case profileConstant.GET_CUSTOM_DOMAIN_DETAILS_F:
      return {
        ...state,
        domainDetails: initialState.domainDetails
      };

    case profileConstant.PUBLISH_DOMAIN_PAGE_R:
    case profileConstant.PUBLISH_DOMAIN_PAGE_S:
    case profileConstant.PUBLISH_DOMAIN_PAGE_F:
      return { ...state }
    case profileConstant.GET_AGENCY_EMAIL_CONFIG_R:
      return {
        ...state,
      };
    case profileConstant.GET_AGENCY_EMAIL_CONFIG_S:
      return {
        ...state,
        agencyEmailConfig: action.data.data || state.agencyEmailConfig,
      };
    case profileConstant.GET_AGENCY_EMAIL_CONFIG_F:
      return {
        ...state,
      };
    case profileConstant.UPDATE_AGENCY_EMAIL_CONFIG: {
      const emailConfig = state.agencyEmailConfig || {};
      return {
        ...state,
        agencyEmailConfig: { ...emailConfig, ...action.data },
      };
    }
    // update Google Auth URL
    case profileConstant.GET_GOOGLE_AUTH_URL_R:
      return {
        ...state,
        authURL: initialState.authURL
      }
    case profileConstant.GET_GOOGLE_AUTH_URL_S:
      return {
        ...state,
        authURL: action?.data?.data?.authUrl
      }
    case profileConstant.GET_GOOGLE_AUTH_URL_F:
      return {
        ...state,
        authURL: initialState.authURL
      }

    case profileConstant.GET_APPLICATION_APPS_R:
      return {
        ...state,
        applicationApps: initialState.applicationApps
      };
    case profileConstant.GET_APPLICATION_APPS_S:
      return {
        ...state,
        applicationApps: action.data.data
      };
    case profileConstant.GET_APPLICATION_APPS_F:
      return {
        ...state,
        applicationApps: initialState.applicationApps
      };

    case profileConstant.GET_USER_CONFIGURED_APPS_R:
      return {
        ...state,
        configuredApps: initialState.configuredApps,
        configuredAppsInfo: initialState.configuredAppsInfo,
        googleEmailId: '',
        outlookEmailId: ''
      };
    case profileConstant.GET_USER_CONFIGURED_APPS_S:
      return {
        ...state,
        ...(action?.data?.data || {})
      };
    case profileConstant.GET_USER_CONFIGURED_APPS_F:
      return {
        ...state,
        configuredApps: initialState.configuredApps,
        configuredAppsInfo: initialState.configuredAppsInfo,
        googleEmailId: '',
        outlookEmailId: ''
      };

    case profileConstant.GET_INVOICE_NOTIFICATION_R:
      return {
        ...state
      };

    // case profileConstant.UPDATE_NOTIFICATIONS_R:
    //   return {
    //     ...state,
    //     notifications_count: {
    //       ...state.notifications_count,
    //       allNewMsgCount: 0
    //     },
    //     notifications_n: []
    //   };
    //   case profileConstant.UPDATE_NOTIFICATIONS_S:
        
    //   return {
    //     ...state,
    //     notifications_count: {
    //       ...state.notifications_count,
    //       allNewMsgCount: 0
    //     },
    //     notifications_n: []
    //   };
      // update Google Auth URL
      case profileConstant.GET_GOOGLE_AUTH_URL_R:
        return {
            ...state,
            authURL: initialState.authURL
        }
    case profileConstant.GET_GOOGLE_AUTH_URL_S:
        return {
            ...state,
            authURL: action?.data?.data?.authUrl
        }
    case profileConstant.GET_GOOGLE_AUTH_URL_F:
        return {
            ...state,
            authURL: initialState.authURL
        }

    case profileConstant.PUBLIC_BOARD_LOGO:
      return {
        ...state,
        profile: action.data,
      }

    case profileConstant.UPDATE_NOTIFICATION_R:
      return {
        ...state,
        loading: true
      };

    case profileConstant.UPDATE_NOTIFICATION_F:
      return {
        ...state,
        loading: false
      };

    case profileConstant.GET_CLONED_STATUS_R:
      return {
        ...state,
        loading: true
      }
    case profileConstant.GET_CLONED_STATUS_S:
      return {
        ...state,
        getClonedStatus: action.data.data,
        loading: false
      }
    case profileConstant.GET_CLONED_STATUS_F:
      return {
        ...state,
        getClonedStatus: action.data,
        loading: false
      }
      
    case profileConstant.SET_SEARCH_TITLE:
      return {
        ...state,
        searchTitle: action.data,
      };   
    default:
      return state;
  }
}
